import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './reducers';
import { unifiedRoutes as routerRoot } from './routes/RouterComponent';
import './locales/i18n';
import { useTranslation } from 'react-i18next';
import { antdLocaleMap } from '@/locales/i18n';
import zhCN from 'antd/locale/zh_CN';

// 解决 jieba.js 等库中 global 未定义的问题
if (typeof global === 'undefined') {
  window.global = window;
}

import './index.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';

// react 19 antd兼容包
import '@ant-design/v5-patch-for-react-19';
import { ConfigProvider } from 'antd';

// 检测是否为移动设备
const isMobileDevice = function () {
  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'mobile',
    'android',
    'iphone',
    'ipad',
    'ipod',
    'ios',
    'windows phone',
  ];
  const isSmallScreen = screen.width < 768;
  return (
    mobileKeywords.some((keyword) => userAgent.includes(keyword)) ||
    isSmallScreen
  );
};

const MOBILE_WIDTH = 1320;
const PC_DESIGN_WIDTH = 1920;
const PC_SCALE_BREAKPOINT = 1440;

const viewportAdapter = function () {
  const meta = document.querySelector('meta[name=viewport]');
  if (!meta) {
    return;
  }

  if (isMobileDevice()) {
    const scale = screen.width / MOBILE_WIDTH;
    meta.setAttribute(
      'content',
      `width=${MOBILE_WIDTH}, initial-scale=${scale}, maximum-scale=${2}, minimum-scale=${scale}, user-scalable=yes`,
    );
    return;
  }

  const viewportWidth = window.innerWidth;
  if (viewportWidth <= PC_SCALE_BREAKPOINT) {
    const scale = viewportWidth / PC_DESIGN_WIDTH;
    meta.setAttribute(
      'content',
      `width=${PC_DESIGN_WIDTH}, initial-scale=${scale}`,
    );
  }
};

viewportAdapter();
window.onorientationchange = viewportAdapter;

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(viewportAdapter, 200);
});
const root = ReactDOM.createRoot(document.getElementById('root'));
const basename = import.meta.env.VITE_BASENAME;

const routerBrowserRoot = createBrowserRouter(routerRoot, {
  basename,
});

function AppRoot() {
  const { i18n } = useTranslation();
  const antdLocale = antdLocaleMap[i18n.language] || zhCN;

  return (
    <Provider store={store}>
      <ConfigProvider locale={antdLocale}>
        <RouterProvider
          router={routerBrowserRoot}
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true,
          }}
        ></RouterProvider>
      </ConfigProvider>
    </Provider>
  );
}

root.render(<AppRoot />);
